import React from 'react';

const FormTextarea = props => {
    const { labelClass, inputClass, name, label, hook, onChange, placeholder, inputValue, disabled, error, required } = props;
    return (
        <React.Fragment>
            <label className={labelClass} htmlFor={hook}>
                {label}
            </label>
            <textarea
                required={required}
                className={inputClass}
                name={name}
                id={hook}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                value={inputValue}></textarea>
            {error && <div className="oi-validation__container oi-validation__error">{error}</div>}
        </React.Fragment>
    );
};

export default FormTextarea;
